/* storybook-check-ignore */
import { Modal } from '@opendoor/bricks/complex/Modal';
import { ModalProps } from 'components/shared/Modal';
import { Flex, Text, Button } from '@opendoor/bricks/core';
import SimpleInfoIcon from './icons/SimpleInfoIcon';
import { ThemedLite } from '@opendoor/bricks/theme/ODThemeLite';
import { exclusives } from '@opendoor/bricks/theme';
import noop from 'lodash/noop';

export default function YouReResponsibleForFeesModal(
  props: Pick<ModalProps, 'isOpen' | 'onRequestClose'>,
) {
  const icon = (
    <Flex
      ml={['0.5rem', '0.5rem', '1.5rem']}
      borderRadius="roundedSquare"
      height="72px"
      width="72px"
      bg="#EBEFFD"
      color="brand50"
      alignItems="center"
      justifyContent="center"
    >
      <SimpleInfoIcon size="40px" />
    </Flex>
  );
  return (
    <Modal
      aria-label="What is Opendoor Exclusives?"
      analyticsName=""
      {...props}
      desktopAndTabletSize="sm"
      headerProps={{
        leftComponent: icon,
      }}
    >
      <ThemedLite
        theme={{
          ...exclusives,
          breakpoints: exclusives.breakpoints,
        }}
      >
        <Flex flexDirection="column" gridGap="0.5rem" mx={['0.5rem', '0.5rem', '1.5rem']}>
          <Text fontWeight="semibold" fontSize="s2" color="brand50">
            Buying an Exclusive with an agent
          </Text>
          <Text color="neutrals90" mb="1.5rem">
            Opendoor Exclusives is designed to be a self-service product that enables buyers to
            purchase directly from Opendoor. That said, we understand that some buyers prefer to
            work with an agent and you are welcome to do so, though any agent commissions are your
            responsibility.
          </Text>
          <Button
            as="a"
            variant="secondary"
            borderColor="brand50"
            color="brand50"
            _hover={{ opacity: 0.8, bg: 'neutrals30', color: 'brand50' }}
            aria-label={null}
            analyticsName=""
            href="/exclusives/faq?toExpand=if-im-working-with-an-agent-how-are-they-compensated"
            onClick={noop}
            target="_blank"
            rel="noopener noreferrer"
          >
            See our FAQ for more details
          </Button>
        </Flex>
      </ThemedLite>
    </Modal>
  );
}
